import { SectionTitle, ToolsCarousel } from '@sloyd/ui';
import { Json } from '../../types';
import { Wrapper } from './ContentTools.style';

export type ContentToolsProps = {
  items: Json[];
};

export function ContentTools(props: ContentToolsProps) {
  const { items } = props;

  return (
    <Wrapper className='ContentTools-wrapper' data-testid='ContentTools-wrapper'>
      <SectionTitle gradient={{ from: '#11998e', to: '#38ef7d' }} title='Tools'>
        Discover essential tools to take your creations further.
      </SectionTitle>
      <ToolsCarousel items={items} />
    </Wrapper>
  );
}

export default ContentTools;
//{ from: '#11998e', to: '#38ef7d' }
